/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { I as Item, d as defineCustomElement$1 } from './p-aIWC4ZEV.js';

const IonItem = Item;
const defineCustomElement = defineCustomElement$1;

export { IonItem, defineCustomElement };
